export default `:host {
  display: inherit;
  border: var(--ids-swappable-active-border);
  height: 100%;
  overflow: auto;
}

:host([active]) {
  border-color: var(--ids-swappable-color-border-active);
}

::slotted(ids-search-field) {
  margin: 0 8px;
  margin-bottom: 8px;
  width: calc(100% - 16px);
  position: sticky;
  top: 0;
}

:host([searchable]) .has-searchfield {
  border-block-end: var(--ids-swaplist-border);
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--ids-card-color-background);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtc3dhcHBhYmxlIiwic291cmNlcyI6WyJpZHMtc3dhcHBhYmxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFJQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGluaGVyaXQ7XG4gIGJvcmRlcjogdmFyKC0taWRzLXN3YXBwYWJsZS1hY3RpdmUtYm9yZGVyKTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBvdmVyZmxvdzogYXV0bztcbn1cblxuOmhvc3QoW2FjdGl2ZV0pIHtcbiAgYm9yZGVyLWNvbG9yOiB2YXIoLS1pZHMtc3dhcHBhYmxlLWNvbG9yLWJvcmRlci1hY3RpdmUpO1xufVxuXG46OnNsb3R0ZWQoaWRzLXNlYXJjaC1maWVsZCkge1xuICBtYXJnaW46IDAgOHB4O1xuICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gIHdpZHRoOiBjYWxjKDEwMCUgLSAxNnB4KTtcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgdG9wOiAwO1xufVxuXG46aG9zdChbc2VhcmNoYWJsZV0pIHtcbiAgLmhhcy1zZWFyY2hmaWVsZCB7XG4gICAgYm9yZGVyLWJsb2NrLWVuZDogdmFyKC0taWRzLXN3YXBsaXN0LWJvcmRlcik7XG4gICAgcG9zaXRpb246IHN0aWNreTtcbiAgICB0b3A6IDA7XG4gICAgei1pbmRleDogMTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pZHMtY2FyZC1jb2xvci1iYWNrZ3JvdW5kKTtcbiAgfVxufVxuIl19 */`;
